






import { Component, Vue } from 'vue-property-decorator';
import WordListB from "@/components/WordListB.vue";

@Component({
  components: {
    WordListB,
  },
})
export default class App extends Vue {}
